export default __webpack_public_path__ + "static/media/07_fosbury.d8aaf633.gif";